import React from "react";
import {
  Button,
  Paper,
  withStyles,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import toastType from "../../../API/CallUtils/tostyNotification";
import CandidatesCall from "../../../API/Cadidates";
import WorkSheetsCall from "../../../API/CandidateWorkSheet";

const styles = (theme) => ({
  paper: {
    //height: "85vh",
    width: "90%",
    padding: "1%",
  },
  candidate: {
    width: "100%",
    minHeight: "200px",
    padding: "5px",
  },
  AddCandidate: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(99, 159, 191,0.2)",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgb(30, 160, 230)",
    "&:hover": {
      backgroundColor: "rgb(99, 159, 191,0.5)",
    },
  },
  ImgPlaceholder: {
    width: "100%",
    height: "185px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
  },
  Remp: {
    width: "100%",
    marginTop: "5px",
    display: "flex",
    justifyContent: "end",
    marginBottom: "10px",
  },
  input: {
    display: "none",
  },
  ImgProp: {
    borderRadius: "8px",
    maxWidth: "100%",
    maxHeight: "185px",
    objectFit: "contain",
    marginTop: "10px",
  },
  Text: {
    width: "100%",
    marginTop: "20px",
  },
  GridDialog: {
    marginLeft: "10px",
  },
});

class candidatesInWorkSheet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DialogCandidate: false,
      Candidate: [],
    };
  }
  componentDidMount = async () => {
    try {
      if (this.props.list) {
        this.setState({
          Candidate: this.props.list,
        });
      }
    } catch (error) {
      toastType.error("Error en la obtención de trabajadores");
      console.log(error);
    }
  };
  deleteCandidates = async (candidateUuid) => {
    try {
      const deleteCan = await CandidatesCall.Delete(candidateUuid);
      if (deleteCan.status === "success") {
        toastType.success("Candidato Eliminado");
        this.showDetailsOfWorkSheet();
      } else {
        toastType.error("No ha sido posible Eliminar el candidato");
        console.log(deleteCan);
      }
    } catch (error) {
      toastType.error("No ha sido posible Eliminar el candidato");
      console.log(error);
    }
  };
  showDetailsOfWorkSheet = async () => {
    try {
      const ShowDetailsWS = await WorkSheetsCall.show(this.props.Uuid);
      console.log(ShowDetailsWS);
      if (ShowDetailsWS.status === "success") {
        this.setState({
          Candidate: ShowDetailsWS.data.candidateWorkSheet.Candidates,
        });
      } else {
        toastType.error("Error refrescando info");
        console.log(ShowDetailsWS);
      }
    } catch (error) {
      toastType.error("Error de conexion");
      console.log("El ERROR", error);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.candidate} elevation={3}>
        {this.state.Candidate.length > 0
          ? [
              <>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>RFC</TableCell>
                      <TableCell>Puesto</TableCell>
                      <TableCell>Eliminar</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.Candidate.map((Article) => {
                      return (
                        <React.Fragment>
                          <TableRow key={Article.uuid}>
                            <TableCell component="th" scope="row">
                              {Article.Employee.User.UserProfile.name}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {Article.Employee.User.UserProfile.rfc}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {Article.employment}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Button
                                color="secondary"
                                onClick={this.deleteCandidates.bind(
                                  this,
                                  Article.uuid
                                )}
                              >
                                <DeleteIcon />
                              </Button>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </>,
            ]
          : [
              <Typography
                align="Center"
                variant="h5"
                color="textPrimary"
                component="p"
                className={classes.Subtitle}
              >
                Sin Candidatos registrados
              </Typography>,
            ]}
      </Paper>
    );
  }
}

export default withStyles(styles)(candidatesInWorkSheet);
